import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import DefaultButton from '../Button'
import { H1, H2, TextLarge } from '../TextPrimitives'
import { ReactComponent as Mail } from '../../icons/Mail.svg'
import { ReactComponent as Home } from '../../icons/Home.svg'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${props => props.theme.colors.text.inverse};
  height: 100%;
`

const Control = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10rem;
`

const Button = styled(DefaultButton)`
  margin-bottom: 10rem;
  align-self: center;
`

const Infos = styled.div`
  display: flex;
  justify-content: center;
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 24px;
  text-align: center;
  min-width: 440px;
`

const styleIcon = icon => styled(icon)`
  margin-bottom: 16px;
`

const SecodaryText = styled.p`
  opacity: 0.66;
`

const Info = ({ icon, primaryText, secodaryText }) => (
  <InfoWrapper>
    <div>{icon}</div>
    <p>{primaryText}</p>
    <SecodaryText>{secodaryText}</SecodaryText>
  </InfoWrapper>
)

const MailIcon = styleIcon(Mail)
const HomeIcon = styleIcon(Home)

// TODO: (2) Only show if AvatarLayer not active
/**
 * Component for the start screen. It contains the title, a subtitle, and a button to start the app.
 */
const Intro = ({ title, subtitle, onClick }) => (
  <Wrapper>
    <div>
      <H1>{title}</H1>
      <H2>{subtitle}</H2>
    </div>
    <Control>
      <Button text="Zeitreise beginnen" size="large" raised onClick={onClick} />
      <TextLarge fontSize={1}>
        <Infos>
          <Info
            icon={<HomeIcon width={48} height={48} />}
            primaryText="Zuhause entdecken unter"
            secodaryText="www.kamerastadt.de"
          />
          <Info
            icon={<MailIcon width={48} height={48} />}
            primaryText="Wissen Sie noch mehr?"
            secodaryText="topografie.kamerastadt@tsd.de"
          />
        </Infos>
      </TextLarge>
    </Control>
  </Wrapper>
)

Intro.defaultProps = {
  title: 'Some title',
  subtitle: 'Some subtitle',
  onClick: x => x,
}

Intro.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default Intro
